import { makeStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: theme.spacing(3),
    backgroundColor: "#F6F8FA",
    background: "linear-gradient(135deg, #F6F8FA 0%, #E8F0FE 100%)",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
  },
  container: {
    maxWidth: 600,
    padding: theme.spacing(4),
    backgroundColor: "white",
    borderRadius: 24,
    boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.08)",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(3),
      margin: theme.spacing(2),
      borderRadius: 16,
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 4,
      background: "linear-gradient(90deg, #F44336 0%, #FF5722 100%)",
    },
  },
  icon: {
    fontSize: 80,
    color: "#F44336",
    marginBottom: theme.spacing(3),
    animation: "$scaleIn 0.5s ease-out",
    [theme.breakpoints.down("xs")]: {
      fontSize: 60,
      marginBottom: theme.spacing(2),
    },
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 700,
    fontSize: "2rem",
    color: "#1A237E",
    animation: "$fadeIn 0.5s ease-out 0.2s both",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.5rem",
      marginBottom: theme.spacing(1),
    },
  },
  subtitle: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
    fontSize: "1.1rem",
    animation: "$fadeIn 0.5s ease-out 0.4s both",
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
      marginBottom: theme.spacing(2),
    },
  },
  infoBox: {
    backgroundColor: "#FFF5F5",
    padding: theme.spacing(3),
    borderRadius: 16,
    marginBottom: theme.spacing(3),
    textAlign: "left",
    border: "1px solid rgba(244, 67, 54, 0.1)",
    animation: "$slideUp 0.5s ease-out 0.6s both",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: 12,
    },
  },
  list: {
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(1),
    },
  },
  listItem: {
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      marginBottom: theme.spacing(1.5),
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  listItemIcon: {
    minWidth: 40,
    marginTop: 4,
    [theme.breakpoints.down("xs")]: {
      minWidth: 32,
    },
  },
  listItemText: {
    color: "#2A3142",
    fontSize: "0.95rem",
    lineHeight: 1.5,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.875rem",
    },
  },
  button: {
    marginTop: theme.spacing(2),
    padding: "12px 32px",
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "1rem",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
    animation: "$fadeIn 0.5s ease-out 0.8s both",
    [theme.breakpoints.down("xs")]: {
      padding: "10px 24px",
      fontSize: "0.875rem",
      marginTop: theme.spacing(1.5),
    },
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.15)",
    },
  },
  "@keyframes scaleIn": {
    "0%": {
      transform: "scale(0)",
      opacity: 0,
    },
    "100%": {
      transform: "scale(1)",
      opacity: 1,
    },
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
      transform: "translateY(10px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  "@keyframes slideUp": {
    "0%": {
      opacity: 0,
      transform: "translateY(20px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
});

export default styles;
